import { render, staticRenderFns } from "./ourTeam.vue?vue&type=template&id=0f9f2650&scoped=true"
import script from "./ourTeam.vue?vue&type=script&lang=js"
export * from "./ourTeam.vue?vue&type=script&lang=js"
import style0 from "./ourTeam.vue?vue&type=style&index=0&id=0f9f2650&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9f2650",
  null
  
)

export default component.exports